import airdrop from '../assets/images/airdrop.png';
import airdropHills from '../assets/images/airdropHills.svg';
import swapBgImage from '../assets/images/swapBgImage.svg';
import alphafi from '../assets/images/alphafi.svg';
import airdropLastBg from '../assets/images/airdropLastBg.svg';
import cetusCompEmpty from '../assets/images/cetus_comp_empty_bg.svg';
import cetusCompEmptyMobile from '../assets/images/cetus_comp_empty_bg_mob.svg';
import dashboardDarkBg from '../assets/images/dashboardDarkBg.svg';
import dashboardLightBg from '../assets/images/dashboardLightBg.svg';
import dashboardDarkMobileBg from '../assets/images/dashboardDarkMobileBg.png';
import dashboardLightMobileBg from '../assets/images/dashboardLightMobileBg.png';
import firstArrowWebMob from '../assets/images/1stArrowWebMob.svg';
import secondArrowlongMob from '../assets/images/2ndArrowlongMob.svg';
import secondArrowWeb from '../assets/images/2ndArrowWeb.svg';
import noDataDark from '../assets/images/noDataDark.svg';
import noDataLight from '../assets/images/noDataLight.svg';
import airdropFirstBgLightWeb from '../assets/images/airdropFirstBgLightWeb.svg';
import airdropFirstBgDarkWeb from '../assets/images/airdropFirstBgDarkWeb.svg';
import airdropFirstBgLightMobile from '../assets/images/airdropFirstBgLightMobile.svg';
const imageMap = {
    airdrop: airdrop,
    swapBgImage: swapBgImage,
    alphafi: alphafi,
    airdropHills: airdropHills,
    airdropLastBg: airdropLastBg,
    cetusCompEmpty: cetusCompEmpty,
    cetusCompEmptyMobile: cetusCompEmptyMobile,
    dashboardDarkBg: dashboardDarkBg,
    dashboardLightBg: dashboardLightBg,
    dashboardDarkMobileBg: dashboardDarkMobileBg,
    dashboardLightMobileBg: dashboardLightMobileBg,
    firstArrowWebMob: firstArrowWebMob,
    secondArrowlongMob: secondArrowlongMob,
    secondArrowWeb: secondArrowWeb,
    noDataDark: noDataDark,
    noDataLight: noDataLight,
    airdropFirstBgLightWeb: airdropFirstBgLightWeb,
    airdropFirstBgDarkWeb: airdropFirstBgDarkWeb,
    airdropFirstBgLightMobile: airdropFirstBgLightMobile,
};
export const getImage = (name) => {
    const image = imageMap[name];
    if (!image) {
        console.error(`Image "${name}" not found in imageMap. Available images:`, Object.keys(imageMap));
        throw new Error(`Image "${name}" not found. Please check the image name or add it to the imageMap.`);
    }
    return image;
};
